export default __webpack_public_path__ + "static/media/closing-img.083006cc.svg";